<div class="review-details">
    <div>
        <div class="review-detail-header">
            <app-review-header [actionNeededVisible]="actionNeededVisible" [readOnlyView]="readOnlyView"
                (openActionNeededDialog)="openActionNeededDialog()">
            </app-review-header>
        </div>
    </div>
    <div class="review-detail-container">
        <lib-review-detail-tabs [isLibraryUsedInSQ]="true"></lib-review-detail-tabs>
    </div>
</div>